import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom';

import { useMutation, useQuery } from '@apollo/client';
import { Box, Container, Stack, TextField, Typography } from '@mui/material';

import { GET_TEMPLATE_RECIPES } from '../../app/graphql/queries';
import { setLoadingRecipeCreating } from '../../app/recipeCreation/createRecipe.slice';
import { recipeCreation } from '../../app/recipeCreation/createRecipe.thunk';
import { useAppDispatch, useAppSelector } from '../../app/store/hooks';
import useRecipeCreation from '../../hooks/useRecipeCreation';
import { CloseIcon } from '../../iconRef/recipePageIcons';
import LoaderButton from '../buttons/loaderButton';
import AIGeneratedRecipeForm from './AIGeneratedRecipeForm';
import CreateRecipeFromScratchForm from './CreateRecipeFromScratchForm';
import DuplicateRecipeForm from './DuplicateRecipeForm';
import { CreationModeEnum } from './utils/constants';
import { INSERT_RECIPE } from '../../app/graphql/mutations';

const warningText = "*Please enter a Recipe name"

const RecipeCreateForm = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const loader = useAppSelector((state) => state.recipeCreation.loadingRecipeCreating)
    const recipeCreationOption = useAppSelector((state) => state.homepage.recipeCreationOption)
    const [insertRecipes] = useMutation(INSERT_RECIPE)
    const user = useAppSelector(state => state.main.user)
    const device = useAppSelector(state => state.main.device)
    const [recipeName, setRecipeName] = useState<string>('')
    const [error, setError] = useState(false)
    const { duplicateRecipe, duplicateTemplateRecipe, generateAIRecipe } = useRecipeCreation()
    const { data: fetchedTemplateRecipeData, loading: fetchingTemplateRecipes } = useQuery(GET_TEMPLATE_RECIPES)
    const templateRecipeId = fetchedTemplateRecipeData?.Recipes_E3[0]?.id;

    useEffect(() => {
        if (recipeCreationOption === null)
            history.push('/')
    }, []);

    return (
        <Container>
            {recipeCreationOption === CreationModeEnum.CREATED_FROM_SCRATCH && <CreateRecipeFromScratchForm />}
            {recipeCreationOption === CreationModeEnum.AI_GENERATED && <AIGeneratedRecipeForm />}
            {recipeCreationOption === CreationModeEnum.DUPLICATE_RECIPE && <DuplicateRecipeForm />}
        </Container>
    )
}

export default RecipeCreateForm
